import { createContext, useContext } from 'react';
import { ProgressStatus } from '@types';
import { UploadFile } from 'antd';

type ProcBasicFormContextType = {
  uploadedFileKey?: string;
  setUploadedFileKey: (fileKey: string) => void;
  imageLink?: string;
  setImageLink: (imageLink: string) => void;
  uploadedImageLink?: string;
  setUploadedImageLink: (imageLink: string) => void;
  fileList?: UploadFile[];
  setFileList: (fileList: UploadFile[]) => void;
  uploadStatus?: ProgressStatus | undefined;
  setUploadStatus: (status: ProgressStatus | undefined) => void;
  uploadProgress?: number;
  setUploadProgress: (progress: number) => void;
  isUploading?: boolean;
  setIsUploading: (uploading: boolean) => void;
};

export const ProcBasicFormContext = createContext<ProcBasicFormContextType>(
  {} as ProcBasicFormContextType,
);

export const useProcBasicFormContext = () => {
  const context = useContext(ProcBasicFormContext);

  if (context === undefined) {
    throw new Error(
      'useProcBasicFormContext must be used within ProcBasicFormProvider',
    );
  }
  return context;
};
